import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

const beats = [
  {
    speaker: 'persona',
    text: 'Oggi in riunione mi sono bloccato appena ho sentito gli occhi addosso.',
  },
  { speaker: 'emovia', text: 'Che cosa è successo dentro di te in quel momento?' },
  { speaker: 'persona', text: 'Ho pensato che avrebbero giudicato ogni parola.' },
  { speaker: 'emovia', text: 'Quel pensiero era già comparso, nei giorni scorsi?' },
] as const;

// Mockup marketing: scambio persona ↔ IA Interrogativa di esempio.
export function InteractionExampleCard({
  className,
  footer,
}: {
  className?: string;
  footer?: ReactNode;
}) {
  return (
    <div className={cn('grid gap-3.5 p-7', className)}>
      <p className="font-accent text-xs uppercase tracking-wide text-muted-foreground">
        Esempio di interazione
      </p>
      {beats.map((beat, index) =>
        beat.speaker === 'persona' ? (
          <div
            key={`${beat.speaker}-${index}`}
            className="max-w-[92%] rounded-2xl rounded-bl-sm bg-gray-light px-4 py-3 text-sm leading-relaxed text-foreground"
          >
            {beat.text}
          </div>
        ) : (
          <div key={`${beat.speaker}-${index}`} className="flex justify-end gap-2.5">
            <div className="max-w-[86%] rounded-2xl rounded-br-sm bg-blue-light px-4 py-3 text-sm leading-relaxed text-primary-dark">
              {beat.text}
            </div>
            <div
              aria-hidden
              className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-[0.7rem] font-bold text-primary-foreground"
            >
              EM
            </div>
          </div>
        ),
      )}
      {footer ? (
        <p className="border-t border-border pt-3.5 text-sm text-muted-foreground">{footer}</p>
      ) : null}
    </div>
  );
}
